/** How the composer's model menu names providers and models. */

export const PROVIDER_NAMES: Record<string, string> = {
    google: 'Google',
    openai: 'OpenAI',
    venice: 'Venice',
    comfyui: 'On this computer',
};

/** "Seedance 2.5 (Venice)" as "Seedance 2.5": the menu groups models by provider. */
export const shortModelLabel = (label: string): string => label.replace(/\s*\((Venice|Local|ComfyUI)\)\s*$/i, '');
